export default {
  getTrialInfo: (state) => state.trialInfo,
  isLoading: (state) => state.loading,
  getActiveTrialSubs: (state) => state.activeTrialSubs,
  getAllTrialStyleIds: (state) => state.allTrialStyleIds,
};
